!((document, Drupal) => {
  "use strict";

  Drupal.behaviors.resourceTeaser = {
    attach: function (context) {
      const teasers = document.querySelectorAll(".resource-teaser");

      const openBody = (teaser) => {
        const body = teaser.querySelector(".resource-teaser__body");
        const cta = teaser.querySelector(".resource-teaser__cta");
        cta.innerHTML = Drupal.t('Show Less');
        body.classList.add("is-expanded");
      };

      const closeBody = (teaser) => {
        const body = teaser.querySelector(".resource-teaser__body");
        const cta = teaser.querySelector(".resource-teaser__cta");
        cta.innerHTML = Drupal.t('Show More');
        body.classList.remove("is-expanded");
      };

      if (teasers) {
        teasers.forEach((teaser, index) => {
          const teaserBody = teaser.querySelector(".resource-teaser__body");
          if (teaserBody.clientHeight > (window.innerWidth > 768 ? 60 : 90)) {
            teaserBody.classList.add('is-truncated');
            const teaserCta = teaser.querySelector(".resource-teaser__cta");
            teaserCta.classList.add('is-shown');
            teaserCta.onclick = (event) => {
              event.preventDefault();
              
              const body = teaser.querySelector(".resource-teaser__body");
              if (body.classList.contains("is-expanded")) {
                closeBody(teaser);
              } else {
                openBody(teaser);
              }
            };
          } else {
            teaserBody.classList.add('is-shown');
          }
        });
      }
    },
  };
})(document, Drupal);
